export default "__VITE_ASSET__KhuGcSrw__"